import { InjectionToken, Provider, Type } from '@angular/core';

import { DotCmsBannerComponent } from '../dot-cms-components/content-types/dot-cms-banner/dot-cms-banner.component';
import { DotCmsBlogComponent } from '../dot-cms-components/content-types/dot-cms-blog/dot-cms-blog.component';
import { DotCmsCarouselComponent } from '../dot-cms-components/content-types/dot-cms-carousel/dot-cms-carousel.component';
import { DotCmsCategoryListManualComponent } from '../dot-cms-components/content-types/dot-cms-category-list-manual/dot-cms-category-list-manual.component';
import { DotCmsFallbackComponent } from '../dot-cms-components/content-types/dot-cms-fallback/dot-cms-fallback.component';
import { DotCmsImageComponent } from '../dot-cms-components/content-types/dot-cms-image/dot-cms-image.component';
import { DotCmsProductCarouselComponent } from '../dot-cms-components/content-types/dot-cms-product-carousel/dot-cms-product-carousel.component';
import { DotCmsProductsTooltipComponent } from '../dot-cms-components/content-types/dot-cms-products-tooltip/dot-cms-products-tooltip.component';
import { DotCmsBannerVideoComponent } from '../dot-cms-components/content-types/dot-cms-video/dot-cms-banner-video/dot-cms-banner-video.component';
import { DotCmsVideoComponent } from '../dot-cms-components/content-types/dot-cms-video/dot-cms-video.component';
import { DotCmsVimeoVideoComponent } from '../dot-cms-components/content-types/dot-cms-video/dot-cms-vimeo-video/dot-cms-vimeo-video.component';
import { DotCmsYoutubeVideoComponent } from '../dot-cms-components/content-types/dot-cms-video/dot-cms-youtube-video/dot-cms-youtube-video.component';
import { DotCmsWebPageContentComponent } from '../dot-cms-components/content-types/dot-cms-web-page-content/dot-cms-web-page-content.component';
import { DotcmsFaqWidgetComponent } from '../dot-cms-components/content-types/dotcms-faq-widget/dotcms-faq-widget.component';
import { DotCmsContentTypeComponent } from '../models/dot-cms-content-types-component.model';
import { DotCmsGlobalCarouselComponent } from '../dot-cms-components/content-types/dot-cms-global-carousel/dot-cms-global-carousel.component';
import { DotCmsMasterCategoryCardComponent } from '../dot-cms-components/content-types/dot-cms-master-category-card/dot-cms-master-category-card.component';

export interface DotCmsContentTypesComponentProvider {
  contentType: string;
  class: Type<DotCmsContentTypeComponent>;
}

export const DOT_CMS_CONTENT_TYPE_COMPONENT = new InjectionToken<DotCmsContentTypesComponentProvider>(
  'dotCmsInjectionToken'
);

export const dotCmsContentTypeComponentProviders: Provider[] = [
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'webPageContent',
      class: DotCmsWebPageContentComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'fallbackNoComponent',
      class: DotCmsFallbackComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Image',
      class: DotCmsImageComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Banner',
      class: DotCmsBannerComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Video',
      class: DotCmsYoutubeVideoComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'VideoVimeo',
      class: DotCmsVimeoVideoComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'DefaultVideo',
      class: DotCmsVideoComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'BannerVideo',
      class: DotCmsBannerVideoComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Carousel',
      class: DotCmsCarouselComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'GlobalCarousel',
      class: DotCmsGlobalCarouselComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'ProductCarousel',
      class: DotCmsProductCarouselComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Blog',
      class: DotCmsBlogComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'Category',
      class: DotCmsCategoryListManualComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'FaqWidget',
      class: DotcmsFaqWidgetComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'ProductsTooltip',
      class: DotCmsProductsTooltipComponent,
    },
    multi: true,
  },
  {
    provide: DOT_CMS_CONTENT_TYPE_COMPONENT,
    useValue: {
      contentType: 'CategoryCard',
      class: DotCmsMasterCategoryCardComponent,
    },
    multi: true,
  },
];
